import Vue from "vue"
import VueUserConfig from "@/mixins/vue-user-config.js"

Vue.use(VueUserConfig)
